<template>
  <div class="btn-open-lib" @click="myOpenLib">
    更多{{resource.text}}
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: {
    resource: {

    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'TOOL'
    ])
  },
  methods: {
    ...mapActions({
      openLib: "resources/openLib",
    }),
    myOpenLib () {
      let navParams = {
        optimized: this.TOOL.optimized,
      };
      navParams.category = this.resource.category;
      navParams.classify = this.resource.classify;
      this.openLib({
        materialType: this.resource.nav,
        navParams
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-open-lib {
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translate(-50%, 0);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 187px;
    height: 40px;
    background: #5778fb;
    opacity: 1;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #7d95f5;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcesArea/btnOpenLib.vue